
<div>
    <p-import-units
        v-model  = "units.show"
        :units   = "units.items"
        :columns = "units.columns"
    />

    <v-tabs
        v-model      = "tabs"
        class        = "mt-3 folder-tabs ml-0 mr-0 pr-0"
        active-class = "folder-tab-active primary"
        height       = "32"
        light
    >
        <v-tab
            v-for = "(entity, index) in data"
            class = "folder-tab"
            :key  = "index"
        >
            {{ $t("importer.entity." + entity.name) }}
        </v-tab>
    </v-tabs>

    <v-tabs-items
        v-model = "tabs"
        class   = "w-100"
        style   = "height: calc(100% - 40px); margin-top: -2px!important;"
    >
        <v-tab-item
            v-for = "(entity, index) in data"
            :key  = "index"
            style = " height: calc(100% + 20px)"
        >
            <div class="v-flex" style="position: fixed; right: 92px; top: 121px; z-index: 10">
                <div class="error--text">({{ entity.errors }} Fehler)</div>
                <div class="warning--text ml-2">({{ entity.warnings }} Warnungen)</div>
            </div>

            <p-import-content
                :id            = "'import-' + entity.name.replace('.', '-') + '-id'"
                :rows          = "entity.rows"
                :columns       = "entity['rowColumns']"
                :unit-columns  = "entity['unitColumns']"
                :size          = "size"
                :show-units    = "true"
                :filter        = "filter"
                :scroll-width  = "columnWidth(entity['rowColumns'])"
                :right-padding = "70"
                :target-format = "true"
                @units         = "onUnits"
            />
        </v-tab-item>
    </v-tabs-items>
</div>
